<app-progress-spinner
  *ngIf="!opportunity && !error"
  class="u-display-block"
  [@fadeInEnter]
></app-progress-spinner>
<div *ngIf="opportunity" fxLayout="row" [@fadeInEnter] fxLayoutGap="8px">
  <ng-container *ngIf="opportunity.rsvp_end_date | appIsPastDate">
    <app-sign-up-banner class="u-display-block" [text]="signupText.past">
    </app-sign-up-banner>
  </ng-container>
  <ng-container *ngIf="!(opportunity.rsvp_end_date | appIsPastDate)">
    <app-sign-up-banner class="u-display-block" [text]="signupText.upcoming">
    </app-sign-up-banner>
  </ng-container>
</div>
<p *ngIf="error" [@fadeInEnter]>
  <ng-container i18n="@@eventsView.signupEventBanner.errorMessage"
    >{ error, select, other {{{ error }}} }</ng-container
  >
</p>
